import { Suspense } from "react";
import "antd/dist/antd.less";
import "./public-path";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import { Spin, message, notification } from "antd";
import { RecoilRoot } from "recoil";
import { QueryClientProvider, QueryClient } from "react-query";
import { setRootProps } from "./share/shared";
import { initializeBurialPoint, EPlatform } from "./gs-web-analytics";
import { envConfig } from "@/envConfig";
const { env, region, lane, domain } = envConfig;

if (region !== "eu") {
  initializeBurialPoint(
    EPlatform.APPLICATION_CENTER,
    domain,
    lane || region || env
  );
}

const queryClient = new QueryClient();
function renderLoading() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin />
    </div>
  );
}

function render(props: any) {
  const { container } = props;
  console.log("container", container);
  ReactDOM.render(
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <HashRouter>
          <Suspense fallback={renderLoading()}>
            <App />
          </Suspense>
        </HashRouter>
      </QueryClientProvider>
    </RecoilRoot>,
    container
      ? container.querySelector("#root")
      : document.querySelector("#root")
  );
}

if (!window.__POWERED_BY_QIANKUN__) {
  render({});
}

export async function bootstrap() {
  console.log("[react16] react app bootstraped");
}

export async function mount(props: any) {
  console.log("microApp props from ui-cloud", props);
  const { rootProps = {}, setLoading } = props;
  setLoading && setLoading(false);
  setRootProps(rootProps);
  render(props);
}

export async function unmount(props: any) {
  const { container } = props;
  message.destroy();
  notification.destroy();
  ReactDOM.unmountComponentAtNode(
    container
      ? container.querySelector("#root")
      : document.querySelector("#root")
  );
}
